export function getRandomItem<T>(arr: T[] | ReadonlyArray<T>): T | undefined {
    return arr[Math.floor(Math.random() * arr.length)];
}
